export var AuditLogActionType = /*#__PURE__*/ function(AuditLogActionType) {
    AuditLogActionType["CostRate"] = "COST_RATE_UPDATE";
    AuditLogActionType["ProfectFinancials"] = "PROJECT_FINANCIALS_FIELD_CHANGE";
    AuditLogActionType["Currency"] = "CURRENCY_UPDATE";
    return AuditLogActionType;
}({});
/**
 * This enum is used to identify resource type in the project audit log framework
 */ export var FinancialsAuditLogMetaName = /*#__PURE__*/ function(FinancialsAuditLogMetaName) {
    FinancialsAuditLogMetaName["ProjectFinancialHours"] = "PROJECT_HOURS";
    FinancialsAuditLogMetaName["ProjectFinancialMinutes"] = "PROJECT_MINUTES";
    FinancialsAuditLogMetaName["ProjectFinancialBudget"] = "PROJECT_BUDGET";
    FinancialsAuditLogMetaName["ProjectBillRates"] = "BILL_RATES";
    FinancialsAuditLogMetaName["ProjectCostRates"] = "COST_RATES";
    FinancialsAuditLogMetaName["Currency"] = "CURRENCY";
    FinancialsAuditLogMetaName["ProjectFinancialsDueDateActual"] = "DUE_DATE_ACTUAL";
    FinancialsAuditLogMetaName["ProjectFinancialsBudgetLogs"] = "PROJECT_FINANCIALS_BUDGET_LOGS";
    return FinancialsAuditLogMetaName;
}({});
/**
 * This enum is used to identify resource type in the general audit log framework
 */ export var AuditLogMetaName = /*#__PURE__*/ function(AuditLogMetaName) {
    AuditLogMetaName["CostRate"] = "COST_RATE";
    AuditLogMetaName["Currency"] = "CURRENCY";
    return AuditLogMetaName;
}({});
export var AuditLogMetaChangeType = /*#__PURE__*/ function(AuditLogMetaChangeType) {
    AuditLogMetaChangeType["Added"] = "ADDED";
    AuditLogMetaChangeType["Updated"] = "UPDATED";
    AuditLogMetaChangeType["Removed"] = "REMOVED";
    return AuditLogMetaChangeType;
}({});
